export default {
  setChannelData(state, data) {
    state.channelData = data;
  },
  setChannelsList(state, data) {
    state.channelsList = data;
  },
  setFollowingList(state, data) {
    state.followingList = data;
  },
  addToFollowingList(state, data) {
    if (Array.isArray(data)) {
      data.forEach(item => {
        if (!state.followingList.some(existing => existing.id === item.id)) {
          state.followingList.push(item);
        }
      });
    } else if (data && !state.followingList.some(existing => existing.id === data.id)) {
      state.followingList.push(data);
    }
  },
  setFollowingCount(state, count) {
    state.followingCount = count;
  },
};
